import { render, staticRenderFns } from "./cmppedidosreservados.vue?vue&type=template&id=156b2131&"
import script from "./cmppedidosreservados.vue?vue&type=script&lang=js&"
export * from "./cmppedidosreservados.vue?vue&type=script&lang=js&"
import style0 from "./cmppedidosreservados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports